/** Country dial codes for the phone input. Tanzania first (home market),
 * then East Africa, then a broad common set. */
export interface Country {
  name: string;
  iso: string;
  dial: string; // includes the leading "+"
  flag: string; // emoji
}

export const COUNTRIES: Country[] = [
  { name: "Tanzania", iso: "TZ", dial: "+255", flag: "🇹🇿" },
  { name: "Kenya", iso: "KE", dial: "+254", flag: "🇰🇪" },
  { name: "Uganda", iso: "UG", dial: "+256", flag: "🇺🇬" },
  { name: "Rwanda", iso: "RW", dial: "+250", flag: "🇷🇼" },
  { name: "Burundi", iso: "BI", dial: "+257", flag: "🇧🇮" },
  { name: "DR Congo", iso: "CD", dial: "+243", flag: "🇨🇩" },
  { name: "Zambia", iso: "ZM", dial: "+260", flag: "🇿🇲" },
  { name: "Malawi", iso: "MW", dial: "+265", flag: "🇲🇼" },
  { name: "Mozambique", iso: "MZ", dial: "+258", flag: "🇲🇿" },
  { name: "South Africa", iso: "ZA", dial: "+27", flag: "🇿🇦" },
  { name: "Nigeria", iso: "NG", dial: "+234", flag: "🇳🇬" },
  { name: "Ghana", iso: "GH", dial: "+233", flag: "🇬🇭" },
  { name: "Ethiopia", iso: "ET", dial: "+251", flag: "🇪🇹" },
  { name: "Egypt", iso: "EG", dial: "+20", flag: "🇪🇬" },
  { name: "Morocco", iso: "MA", dial: "+212", flag: "🇲🇦" },
  { name: "United States", iso: "US", dial: "+1", flag: "🇺🇸" },
  { name: "United Kingdom", iso: "GB", dial: "+44", flag: "🇬🇧" },
  { name: "Canada", iso: "CA", dial: "+1", flag: "🇨🇦" },
  { name: "France", iso: "FR", dial: "+33", flag: "🇫🇷" },
  { name: "Germany", iso: "DE", dial: "+49", flag: "🇩🇪" },
  { name: "Netherlands", iso: "NL", dial: "+31", flag: "🇳🇱" },
  { name: "Italy", iso: "IT", dial: "+39", flag: "🇮🇹" },
  { name: "Spain", iso: "ES", dial: "+34", flag: "🇪🇸" },
  { name: "United Arab Emirates", iso: "AE", dial: "+971", flag: "🇦🇪" },
  { name: "Saudi Arabia", iso: "SA", dial: "+966", flag: "🇸🇦" },
  { name: "India", iso: "IN", dial: "+91", flag: "🇮🇳" },
  { name: "China", iso: "CN", dial: "+86", flag: "🇨🇳" },
  { name: "Australia", iso: "AU", dial: "+61", flag: "🇦🇺" },
  { name: "Brazil", iso: "BR", dial: "+55", flag: "🇧🇷" },
];

export const DEFAULT_COUNTRY = COUNTRIES[0]; // Tanzania
